<template>
  <footer class="footer">
    <div class="footer-inner">
      <nav class="footer-nav">
        <router-link :to="{name: 'Place', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuLocation') }}</router-link>
        <router-link :to="{name: 'Notice', params : { 'locale' : locale === 'en' ? 'en' : undefined}, query : { page : 1}}">{{ $t('menuNotices') }}</router-link>

        <!-- 국문 -->
        <template v-if="locale === 'ko'">
          <router-link :to="{name: 'Policy', params : { 'locale' : locale === 'en' ? 'en' : undefined }}"><strong>{{ $t('menuPolicy') }}</strong></router-link>
          <router-link :to="{name: 'questionPartnership', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuPartnerships') }}</router-link>
          <router-link :to="{name: 'CustomerServiceCenter', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuInformationCenter') }}</router-link>
        </template>

        <!-- 영문 -->
        <template v-else-if="locale === 'en'">
          <router-link :to="{name: 'questionPartnership', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuPartnerships') }}</router-link>
          <router-link :to="{name: 'InformationCenterConsult', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuInformationCenter') }}</router-link>
        </template>
      </nav>
      <div class="footer-family link-select">
        <button
          class="link-select-button"
          type="button"
          :class="{
            'link-select-active': isFamilyShow
          }"
          @click="onFamilyToggle"
        >
          <span>{{ $t('affiliatedWebsites') }}</span>
          <span class="down"><icon-chevron-down /></span>
        </button>
        <transition name="link-select">
          <ul v-if="isFamilyShow" class="link-select-list">
            <li v-for="(item, key) in familySite" :key="key" :data-level="item.connectionSiteTypeLevel">
              <a
                :href="item.connectionSiteUrl"
                target="_blank"
                @click="setGtag({
                  action: 'click',
                  name: '관련사이트 drop-down',
                  category: '관련사이트 drop-down',
                  label: `GNB_${locale === 'ko' ? item.connectionSiteKoreaName : item.connectionSiteEnglishName} 연결 링크`,
                  page: '공통'
                })"
              >{{ locale === 'ko' ? item.connectionSiteKoreaName : item.connectionSiteEnglishName }}</a>
            </li>
          </ul>
        </transition>
      </div>
      <div class="footer-address">
        <h2>{{ $t('woowaCorp') }}</h2>
        <address>
          <p>
            <span>{{ $t('bzNumber') }} : 120-87-65763</span>
            <i>|</i>
            <span>{{ $t('footerCeo') }}</span>
            <i>|</i>
            <span>{{ $t('address') }} : {{ $t('addressDetail') }}</span>
          </p>
        </address>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '@/mixins/menu'
import gtag from '@/mixins/gtag'

export default {
  components: {
    iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    // iconCcm: () => import('@/static/svg/ccm.svg')
  },
  mixins: [
    menu,
    gtag
  ],
  data () {
    return {
      isFamilyShow: false
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
      siteConnectionLevelSecond: 'site/siteConnectionLevelSecond',
      siteConnectionLevelThird: 'site/siteConnectionLevelThird',
      writingCategories: 'categories/get_writing_categories'
    }),
    familySite () {
      return [
          ...this.siteConnectionLevelSecond,
          ...this.siteConnectionLevelThird
      ]
    }
  },
  methods: {
    // onGoSticky () {
    //   if (this.$route.params && this.$route.params.child) {
    //     const isPcHeader = window.matchMedia('(min-width: 980px)')
    //     const offset = isPcHeader.matches ? 71 : 50
    //
    //     const targetOffsetTop = document.getElementById(this.$route.params.child).offsetTop - offset
    //
    //     window.scrollTo('scrollBehavior' in document.documentElement.style ? {
    //       // behavior: 'smooth',
    //       top: targetOffsetTop
    //     } : {
    //       top: targetOffsetTop
    //     })
    //   }
    // },
    onFamilyToggle () {
      this.isFamilyShow = !this.isFamilyShow

      const docEvents = (e) => {
        if (!e.target.closest('.footer-family')) {
          this.isFamilyShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    }
  }
}
</script>
